module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "撤除申请详情"
    }
  }, [_c('div', {
    staticClass: "view_mian"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("申请人基本信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.showWran ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("申请人姓名：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("申请人电话：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("所在单位：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.showWran ? 'showIcon' : 'hideIcon',
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v("个人身份证明：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "title_sty"
  }, [_vm._v("待撤文章信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("题目名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("作者：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("单位允许撤除证明：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("检测报告单：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("待撤文章位置：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("申请提交时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "title_sty"
  }, [_vm._v("审核意见")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核状态：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核意见：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "reApply_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reApply
    }
  }, [_vm._v("重新提交申请")]), _vm._v(" "), _c('div', {
    staticClass: "title_sty"
  }, [_vm._v("撤除结果")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("撤除结果：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("结果详情：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("审核时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v("XXXXX")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn_box"
  }, [_c('el-button', {
    staticClass: "backRecord_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backRecord
    }
  }, [_vm._v("返回申请记录列表")])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7685543a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/checkerPages/viewBase.vue
// module id = 1196
// module chunks = 1